import React from 'react';
import { Redirect } from 'react-router';
import { Button, Badge, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import { getSpecificTextServer, deleteTextWithId, uploadNewFilesToDb } from '../functions/adminFunctions';

const required = (val) => val && val.length;
const isNumber = (val) => !isNaN(Number(val));


class TextTools extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specificText: "",
            retrievedText: [],
            uploadResult: "",
            fileNumber: "",
            fileNumberError: "",
            fileNameError: ""
        }
    }

    handleInput = (event) => {
        var name = event.target.name;
        var value = event.target.value;
        if (name === "textname") {
            this.setState({
                specificText: value
            });
        }
        else if (name === "fileNumber") {
            this.setState({
                fileNumber: value
            });
        }
    }

    validate = (event) => {
        var name = event.target.name;
        var value = event.target.value;
        if (name === "textname") {
            console.log("asdasd");
            if (!required(this.state.specificText)) {
                this.setState({
                    fileNameError: "Filename cannot be empty"
                });
            }
            else {
                this.setState({
                    fileNameError: ""
                });
            }
        }
        else if (name === "fileNumber") {
            if (!required(this.state.fileNumber)) {
                this.setState({
                    fileNumberError: "File Number cannot be empty"
                });
            }
            else if (!isNumber(this.state.fileNumber)) {
                this.setState({
                    fileNumberError: "File Number must be a number"
                });
            }
            else if (required(this.state.fileNumber) && isNumber(this.state.fileNumber)) {
                this.setState({
                    fileNumberError: ""
                });
            }
        }
    }

    getSpecificText = () => {
        this.setState({
            uploadResult: ""
        });
        getSpecificTextServer(this.state.specificText)
            .then((text) => {
                console.log(text);
                this.setState({
                    retrievedText: text
                });
            })
    }

    deleteText = (hindiTextId, fileNumber) => {
        deleteTextWithId(hindiTextId, fileNumber)
            .then((resp) => {
                this.setState({
                    retrievedText: []
                });
                console.log(resp);
            })
            .catch((err) => console.log(err));
    }

    // uploadFiles = ()=>{
    //     this.setState({
    //         uploadResult:""
    //     });
    //     uploadNewFilesToDb(this.state.start,this.state.end)
    //     .then((resp)=>{
    //         if(resp){
    //             console.log(resp);
    //             this.setState({
    //                 uploadResult:resp.success?"Successful":"Failed"
    //             });
    //         }
    //         else{
    //             this.setState({
    //                 uploadResult:"Failed"
    //             });
    //         }
    //     })
    // }

    uploadFile = () => {
        if (required(this.state.fileNumber) && isNumber(this.state.fileNumber)) {
            this.setState({
                uploadResult: ""
            });
            uploadNewFilesToDb(this.state.fileNumber)
                .then((resp) => {
                    if (resp) {
                        console.log(resp);
                        this.setState({
                            uploadResult: resp.success ? "Successful" : "Failed"
                        });
                    }
                    else {
                        this.setState({
                            uploadResult: "Failed"
                        });
                    }
                });
        }
        else {
            this.setState({
                uploadResult: "Please fix the errors in File number"
            });
        }
    }


    render() {

        if (this.state.retrievedText != [] && this.state.retrievedText !== undefined) {
            var textList = this.state.retrievedText.map((text) => {
                return (
                    <div
                        className="mt-2 pl-2 activeUserList">
                        <li key={text._id}>
                            <h6>File Number: {text.fileNumber}</h6>
                            <h6>Text: {text.hindiText}</h6>
                            <h6>Status: {text.status ? "Finished" : "Pending"}</h6>
                            <h6>Text: {text._id}</h6>
                        </li>
                        <div className="row m-auto">
                            <div className="ml-2">
                                <h4><Button color="danger"
                                    onClick={() => this.deleteText(text._id, text.fileNumber)}
                                >Delete</Button></h4>
                            </div>
                        </div>
                    </div>
                );
            });
        }
        return (
            <div>
                <div className="mt-2">
                    <div className="row">
                        <div className="mb-1 pb-1">
                            <Input
                                type="text"
                                name="textname"
                                onChange={this.handleInput}
                                value={this.state.specificText}
                                onBlur={this.validate}
                            />
                        </div>
                        <div className="ml-1">
                            <h4><Button color="info" onClick={() => this.getSpecificText()}>Find File</Button></h4>
                        </div>
                    </div>
                    <div className="row">
                        <h6><Badge color="danger">{this.state.fileNameError}</Badge></h6>
                    </div>
                </div>

                <div className="mt-2">
                    <div className="row">
                        <div className="mb-1 pb-1">
                            <Input
                                type="text"
                                name="fileNumber"
                                onChange={this.handleInput}
                                value={this.state.fileNumber}
                                onBlur={this.validate}
                            />
                        </div>
                        <div className="ml-1">
                            <h4><Button color="info" onClick={() => this.uploadFile()}>Upload File</Button></h4>
                        </div>
                    </div>
                    <div className="row">
                        <h6><Badge color="danger">{this.state.fileNumberError}</Badge></h6>
                    </div>
                </div>

                <div className="row">
                    <h4><Badge>{this.state.uploadResult}</Badge></h4>
                </div>
                <div>
                    {textList}
                </div>
            </div>
        )
    }
}

export default TextTools;